/**
 * Whether the responses view shows its risk surface: the overview card, the
 * risk filters, the scoring progress, the per-question findings. Admins see
 * the live run, published or not. Sponsors see only a run an admin has
 * published; until then the pending banner is all they get. A VQQ that never
 * asked for risk scoring has no surface at all. A model preview always shows,
 * it is the viewer's own and nothing of it is persisted.
 */
export function riskSurfaceEnabled({
  isPreviewing = false,
  canSeeRisk = false,
  snapshot = null,
  isAdmin = false,
} = {}) {
  if (isPreviewing) return true;
  if (!canSeeRisk || !snapshot) return false;

  const mode = typeof snapshot.mode === "string" ? snapshot.mode : null;
  const hasScoringRun = !!snapshot.scoring_run_id;
  // Mode comes from the purchase entitlement. An admin who ran the engine on
  // a VQQ bought without risk scoring still gets the surface for that run.
  const requested = (!!mode && mode !== "None") || (isAdmin && hasScoringRun);
  if (!requested) return false;

  return isAdmin || snapshot.is_published === true;
}
